import axios from 'axios';

export default {
    findItems (page, pageSize,isLightData, reference, selectedSection, selectedPaperType, requestTimestamp) {
        return axios.get('/api/items/list', { params: {page: page, pageSize: pageSize, isLightData:isLightData, reference:reference, selectedSection:selectedSection, selectedPaperType:selectedPaperType, requestTimestamp:requestTimestamp } })

        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {console.log(error);})
    },
    findItemsPrices(){
         return axios.get('/api/items/prices')

        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {console.log(error);})
    },

    getAllSection() {
        return axios.get('/api/items/sections')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {console.log(error);})
    },

    getNewItems() {
        return axios.get('/api/items/get/new-item')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {console.log(error);})
    },

    setVisitItem(itemId ,originType){
        return axios.post('/api/items/visit', {itemId: itemId , originType:originType})
        .then(response => {
            if (response && response.data) {
                return response.data;
            }
        })
        .catch(error => {console.log(error);})
    }

}